module.exports = __webpack_public_path__ + "img/gift_icon.cf4640da.svg";